import React, { useState } from 'react';
import { Drawer, Input, Card, Image, Typography } from 'antd';
import { prUrl } from '../config.js'
import EventDetails from './EventDetails';
import search from '../../images/Union.svg'
import Icon from "@ant-design/icons";
import locationIcon from '../../images/location.png'

const {Title} = Typography

const EventListDrawer = (props) => { 
    const [event, setEvent] = useState(null)
    const [isEventModalOpen, setIsEventModalOpen] = useState(false)
    const [active, setActive] = useState('')
    const handleEventModalShow = () => {
        setIsEventModalOpen(!isEventModalOpen)
        setActive('')
    }
    const handleOnClick = (event, index) => {
        handleEventModalShow()
        setEvent(event)
        setActive(index)
    }
    const searchIcon = () => (
        <Image src={search} preview={false}/>
    )
    const location = () => (
        <Image src={locationIcon} preview={false}/>
    )
    const gotoMarker = (marker) => {
        props.globe.goTo(marker.position.latitude, marker.position.longitude, 10e4)
    }

    const GotoButton = (props) => {    
        return (
            <Icon component={location} onClick={(e) => gotoMarker(props.marker, e)}/>
        );
    }
    const { globe } = props
    return(
        <React.Fragment>
            <Drawer
                className='listDrawer'
                title={<span className="drawerTitle">热点事件列表</span>}
                placement="left"
                closable={false}
                onClose={props.handleEventDrawerShow}
                visible={props.isEventDrawerShow}
                getContainer={false}
                width={'450'}>
                <div className="drawerSearch">
                    <Input placeholder="请输入筛选条件……" type="text" onKeyUp={props.handleFilter}/>
                    <div className="drawerSearchIcon">
                        <Icon component={searchIcon}/>
                    </div>
                </div>
                {
                    props.filteredEvents.map((item, index) => 
                        <Card className={active === index ? 'drawer-list-item-active drawer-list-item' : 'drawer-list-item'} hoverable title={<Title onClick={(e) => handleOnClick(item.event, index, e)} level={5} style={{cursor:'pointer'}}>{item.event.time}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{item.event.country}</Title>} extra={<GotoButton marker={item.marker} globe={globe}/>} style={{ width: 385, border:'false' }} > 
                        {/* <Card hoverable title={<Title level={5} style={{cursor:'pointer'}}>{item.event.time}</Title>} extra={<GotoButton marker={item.marker} globe={globe}/>} style={{ width: 385, border:'false' }} > */}
                            {item.event.image!=="" && <Image visible={item.event.image} src={prUrl + item.event.image} preview={false} style={{cursor:'pointer'}} onClick={(e) => handleOnClick(item.event, index, e)}/>}
                            <p style={{cursor:'pointer'}} onClick={(e) => handleOnClick(item.event, index, e)}>{item.event.text}</p>
                        </Card>
                    )
                }
            </Drawer>
            {
                isEventModalOpen ?
                <EventDetails isModalOpen={isEventModalOpen} event={event} handleModalShow={handleEventModalShow}/> : ''

            }
        </React.Fragment>
    )
};

export default EventListDrawer;